var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchGoods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 2.5C14.1755 2.5 14.3451 2.57024 14.4701 2.69526C14.5951 2.82029 14.6654 2.98986 14.6654 3.16667V7.83333C14.6654 8.01014 14.5951 8.17971 14.4701 8.30474C14.3451 8.42976 14.1755 8.5 13.9987 8.5H12.6647L12.6654 13.8333C12.6654 14.0101 12.5951 14.1797 12.4701 14.3047C12.3451 14.4298 12.1755 14.5 11.9987 14.5H3.9987C3.82189 14.5 3.65232 14.4298 3.52729 14.3047C3.40227 14.1797 3.33203 14.0101 3.33203 13.8333L3.33136 8.49933L1.9987 8.5C1.82189 8.5 1.65232 8.42976 1.52729 8.30474C1.40227 8.17971 1.33203 8.01014 1.33203 7.83333V3.16667C1.33203 2.98986 1.40227 2.82029 1.52729 2.69526C1.65232 2.57024 1.82189 2.5 1.9987 2.5H5.9987C5.9987 3.03043 6.20941 3.53914 6.58448 3.91421C6.95956 4.28929 7.46826 4.5 7.9987 4.5C8.52913 4.5 9.03784 4.28929 9.41291 3.91421C9.78798 3.53914 9.9987 3.03043 9.9987 2.5H13.9987Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchGoods);
export default __webpack_public_path__ + "static/media/merchGoods.31c221fb234d5634fd5663a08c840652.svg";
export { ForwardRef as ReactComponent };